// Libs
import React, { Component } from 'react'
import { Field } from 'redux-form'
import _ from 'lodash'

// CSS
import "./styles.scss"

// Components
import CaptureFilterField from '../CaptureFilterField'
import CaptureFilterSearch from '../CaptureFilterSearch'

class CaptureFilterSection extends Component {
  render() {
    const { type, name, title, beta, options, sorted, handleReset, captureFilter } = this.props
    let sortedOptions = options
    let selected = false

    if (sorted) {
      sortedOptions = _.orderBy(options, [options => options.label.toLowerCase()], ['asc'])
    }

    if (captureFilter && captureFilter.values && !_.isEmpty(captureFilter.values[name])) {
      selected = true
    }

    return (
      <div className="capture-filter-section">
        <div className="capture-filter-section__header">
          <div>
            <p className="capture-filter-section__title" style={{ color: selected && '#12B7A3' }}>{title}</p>
            {beta &&
              <p className="capture-filter-section__title">BETA</p>
            }
          </div>
          <p className="capture-filter-section__reset" onClick={handleReset}>limpar</p>
        </div>
        {name === 'search' &&
          <Field
            component={CaptureFilterSearch}
            name={name}
            placeholder="Buscar por palavra chave"
            section={title}
          />
        }
        {name !== 'search' && sortedOptions.map((option, index) => (
          <div key={index}>
            <Field
              index={index}
              component={CaptureFilterField}
              type={type}
              name={name}
              section={title}
              value={type !== 'checkbox' ? option.value : ''}
              option={option}
            />
            {option.subtitle &&
              <p className="capture-filter-section__subtitle">{option.subtitle}</p>
            }
          </div>
        ))}
      </div>
    )
  }
}

export default CaptureFilterSection
